export default __webpack_public_path__ + "static/banner-7-c6c01d61fb854d20ec69d2a12d2614c5.svg";